import { apiFetch } from './client'

export type SearchResultKind = 'project' | 'pay_app' | 'vendor'

export interface SearchResultBase {
  kind: SearchResultKind
  label: string
  subtitle: string | null
}

export interface ProjectSearchResult extends SearchResultBase {
  kind: 'project'
  id: number
}

export interface PayAppSearchResult extends SearchResultBase {
  kind: 'pay_app'
  id: number
  project_id: number
  app_number: number
}

export interface VendorSearchResult extends SearchResultBase {
  kind: 'vendor'
  id: number
  vendor_user_id: number | null
}

export type SearchResult = ProjectSearchResult | PayAppSearchResult | VendorSearchResult

export async function fetchSearchResults(q: string): Promise<SearchResult[]> {
  const trimmed = q.trim()
  if (trimmed.length < 2) return []
  const res = await apiFetch<{ data: { results: SearchResult[] } }>(
    'GET',
    `/api/search?q=${encodeURIComponent(trimmed)}`,
  )
  return res.data?.results ?? []
}
